// Mock data para postos de carregamento e utilizadores

export const mockPostos = [
  {
    id: 'P1-PRAGAL',
    nome: 'Posto 1',
    local: 'Pragal',
    coordenadas: [38.6614, -9.0702],
    tipo: 'AC',
    potencia: 22,
    estado: 'Disponível',
    fabricante: 'ABB',
    modelo: 'Terra AC',
    numeroSerie: 'TAC-2024-001',
    dataInstalacao: '2023-01-15',
    utilizacaoMensal: 85,
    totalCarregamentos: 342,
    energiaFornecida: 4580,
    ultimaManutencao: '2024-11-01'
  },
  {
    id: 'P2-PRAGAL',
    nome: 'Posto 2',
    local: 'Pragal',
    coordenadas: [38.6618, -9.0708],
    tipo: 'DC',
    potencia: 50,
    estado: 'Em Uso',
    fabricante: 'Efacec',
    modelo: 'QC45',
    numeroSerie: 'QC45-2024-002',
    dataInstalacao: '2023-02-20',
    utilizacaoMensal: 92,
    totalCarregamentos: 458,
    energiaFornecida: 6720,
    ultimaManutencao: '2024-10-15'
  },
  {
    id: 'P1-STAPOLONIA',
    nome: 'Posto 1',
    local: 'Santa Apolónia',
    coordenadas: [38.7153, -9.1240],
    tipo: 'AC',
    potencia: 22,
    estado: 'Disponível',
    fabricante: 'Wallbox',
    modelo: 'Pulsar Plus',
    numeroSerie: 'PP-2024-003',
    dataInstalacao: '2023-03-10',
    utilizacaoMensal: 78,
    totalCarregamentos: 289,
    energiaFornecida: 3890,
    ultimaManutencao: '2024-11-05'
  },
  {
    id: 'P2-STAPOLONIA',
    nome: 'Posto 2',
    local: 'Santa Apolónia',
    coordenadas: [38.7158, -9.1235],
    tipo: 'DC',
    potencia: 50,
    estado: 'Disponível',
    fabricante: 'ABB',
    modelo: 'Terra HP',
    numeroSerie: 'THP-2024-004',
    dataInstalacao: '2023-03-10',
    utilizacaoMensal: 88,
    totalCarregamentos: 412,
    energiaFornecida: 5940,
    ultimaManutencao: '2024-10-20'
  },
  {
    id: 'P1-EVORA',
    nome: 'Posto 1',
    local: 'Évora',
    coordenadas: [38.5714, -7.9094],
    tipo: 'AC',
    potencia: 22,
    estado: 'Manutenção',
    fabricante: 'ABB',
    modelo: 'Terra AC',
    numeroSerie: 'TAC-2024-005',
    dataInstalacao: '2023-04-05',
    utilizacaoMensal: 0,
    totalCarregamentos: 267,
    energiaFornecida: 3560,
    ultimaManutencao: '2024-12-01'
  },
  {
    id: 'P2-EVORA',
    nome: 'Posto 2',
    local: 'Évora',
    coordenadas: [38.5720, -7.9100],
    tipo: 'DC',
    potencia: 100,
    estado: 'Disponível',
    fabricante: 'Efacec',
    modelo: 'QC100',
    numeroSerie: 'QC100-2024-006',
    dataInstalacao: '2023-04-05',
    utilizacaoMensal: 95,
    totalCarregamentos: 523,
    energiaFornecida: 8760,
    ultimaManutencao: '2024-11-10'
  },
  {
    id: 'P1-FREIXO',
    nome: 'Posto 1',
    local: 'Freixo',
    coordenadas: [41.1496, -8.5830],
    tipo: 'AC',
    potencia: 22,
    estado: 'Disponível',
    fabricante: 'Wallbox',
    modelo: 'Pulsar Plus',
    numeroSerie: 'PP-2024-007',
    dataInstalacao: '2023-05-12',
    utilizacaoMensal: 82,
    totalCarregamentos: 298,
    energiaFornecida: 4120,
    ultimaManutencao: '2024-11-08'
  },
  {
    id: 'P2-FREIXO',
    nome: 'Posto 2',
    local: 'Freixo',
    coordenadas: [41.1500, -8.5825],
    tipo: 'DC',
    potencia: 50,
    estado: 'Disponível',
    fabricante: 'ABB',
    modelo: 'Terra HP',
    numeroSerie: 'THP-2024-008',
    dataInstalacao: '2023-05-12',
    utilizacaoMensal: 90,
    totalCarregamentos: 445,
    energiaFornecida: 6340,
    ultimaManutencao: '2024-10-25'
  }
];

export const mockUtilizadores = [
  {
    id: 'U001',
    nome: 'João Silva',
    email: 'joao.silva@infraestruturasdeportugal.pt',
    telefone: '+351 912 345 678',
    cargo: 'Gestor Técnico',
    departamento: 'Gestão de Infraestruturas',
    dataRegisto: '2023-01-10',
    totalCarregamentos: 47,
    energiaConsumida: 1245,
    tempoTotal: 98,
    permissoes: {
      Pragal: ['P1-PRAGAL', 'P2-PRAGAL'],
      'Santa Apolónia': ['P1-STAPOLONIA', 'P2-STAPOLONIA'],
      'Évora': ['P1-EVORA', 'P2-EVORA']
    },
    ativo: true
  },
  {
    id: 'U002',
    nome: 'Maria Santos',
    email: 'maria.santos@infraestruturasdeportugal.pt',
    telefone: '+351 913 456 789',
    cargo: 'Engenheira Civil',
    departamento: 'Obras e Manutenção',
    dataRegisto: '2023-02-15',
    totalCarregamentos: 38,
    energiaConsumida: 982,
    tempoTotal: 76,
    permissoes: {
      Pragal: ['P1-PRAGAL'],
      'Santa Apolónia': ['P1-STAPOLONIA']
    },
    ativo: true
  },
  {
    id: 'U003',
    nome: 'Pedro Costa',
    email: 'pedro.costa@infraestruturasdeportugal.pt',
    telefone: '+351 914 567 890',
    cargo: 'Técnico de Manutenção',
    departamento: 'Manutenção',
    dataRegisto: '2023-03-20',
    totalCarregamentos: 52,
    energiaConsumida: 1456,
    tempoTotal: 112,
    permissoes: {
      'Évora': ['P1-EVORA', 'P2-EVORA'],
      Freixo: ['P1-FREIXO', 'P2-FREIXO']
    },
    ativo: true
  },
  {
    id: 'U004',
    nome: 'Ana Ferreira',
    email: 'ana.ferreira@infraestruturasdeportugal.pt',
    telefone: '+351 915 678 901',
    cargo: 'Coordenadora de Projetos',
    departamento: 'Gestão de Projetos',
    dataRegisto: '2023-04-05',
    totalCarregamentos: 29,
    energiaConsumida: 745,
    tempoTotal: 58,
    permissoes: {
      'Santa Apolónia': ['P1-STAPOLONIA', 'P2-STAPOLONIA']
    },
    ativo: true
  },
  {
    id: 'U005',
    nome: 'Carlos Alves',
    email: 'carlos.alves@infraestruturasdeportugal.pt',
    telefone: '+351 916 789 012',
    cargo: 'Diretor de Operações',
    departamento: 'Operações',
    dataRegisto: '2023-01-05',
    totalCarregamentos: 61,
    energiaConsumida: 1678,
    tempoTotal: 134,
    permissoes: {
      Pragal: ['P1-PRAGAL', 'P2-PRAGAL'],
      'Santa Apolónia': ['P1-STAPOLONIA', 'P2-STAPOLONIA'],
      'Évora': ['P1-EVORA', 'P2-EVORA'],
      Freixo: ['P1-FREIXO', 'P2-FREIXO']
    },
    ativo: true
  }
];
